module.exports = "/shared/img/lucky-balls.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/lucky-balls.png
// module id = 441
// module chunks = 13